<a class="heart-button">
  <img src="/assets/images/gallery/heart-off-icon.png">
  <img src="/assets/images/gallery/heart-on-icon.png">
</a>
